import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { Button } from '../components/ui/button';
import '../styles/Profile.css';

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // Determine if we're on the home page
  const isHomePage = location.pathname === '/';
  const isScrolled = typeof window !== 'undefined' && window.scrollY > 50;
  const isDarkBackground = isScrolled || !isHomePage;

  const handleLogout = async () => {
    try {
      await logout();
      setIsOpen(false);
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (!user) {
    console.log('No user in ProfileDropdown');
    return null;
  }

  // Get initials from user full name
  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          className={`profile-button ${isDarkBackground ? 'profile-button-dark' : 'profile-button-light'}`}
        >
          <div className="profile-avatar">
            {getInitials(user.fullName)}
          </div>
          <span className="profile-name">{user.fullName || 'User'}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="profile-dropdown">
        <DropdownMenuLabel className="profile-label">
          <div className="profile-info">
            <p className="profile-email">{user.email}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="logout-item">
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ProfileDropdown;
